<template>
  <div :class="['wrapper', { chart: isChart }]">
    <div class="metric-item skeleton" v-if="!metric.id">
      <div class="icon highlight"></div>

      <div class="metric-info mt-2 mr-4 ml-4">
        <h4 class="highlight"></h4>
        <div class="bar highlight"></div>
      </div>
    </div>

    <div
      :class="[
        'metric-item',
        'ie-11-img',
        classItem,
        { 'no-border': metric.noBorder },
      ]"
      v-metric-color
      :data-metric-value="normalizeScore"
      v-show="metric.id && !isChart"
      @click="metricLink"
    >
      <div
        class="icon"
        v-metric-color
        :data-metric-value="normalizeScore"
        :value="score"
        v-if="metric.image"
      >
        <div :style="{ 'background-image': `url(${metric.image})` }"></div>
      </div>

      <div class="metric-info">
        <h4>{{ metric.label }}</h4>
        <p class="mt-1" v-if="metric.text">{{ metric.text }}</p>
        <b-link class="show-details" v-if="metric.link">
          {{ resources.component.metricItem.showDetails }}
        </b-link>
        <div class="bar">
          <b-progress :max="10" class="flex-100 ie-11-progress" show-progress>
            <b-progress-bar
              v-metric-color
              :data-metric-value="normalizeScore"
              :value="score"
              :label="' '"
            ></b-progress-bar>
          </b-progress>
          <span
            class="label"
            v-metric-color
            :data-metric-value="normalizeScore"
            >{{ metric.scoreLabel }}</span
          >
        </div>
      </div>
    </div>

    <div class="metric-item-chart" v-show="metric.id && isChart">
      <b-row class="m-0">
        <div
          class="icon mr-3"
          v-metric-color
          :data-metric-value="normalizeScore"
          v-if="metric.image"
        >
          <div :style="{ 'background-image': `url(${metric.image})` }"></div>
        </div>

        <div class="metric-info">
          <div class="label">{{ metric.label }}</div>
          <b-link class="show-details" v-if="metric.link" :to="metric.link">{{
            resources.component.metricItem.showDetails
          }}</b-link>
        </div>
      </b-row>
      <HistoricChart :history="metric.history"></HistoricChart>
    </div>
    <modal-plans
      ref="component-modal-plans"
      :title="resources.page.reports.engagement.modalPlans.title"
    >
    </modal-plans>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HistoricChart from '@/components/Reports/HistoricChart.vue'
import ModalPlans from '@/components/Modal/ModalPlans.vue'

const props = {
  metric: {
    default: function() {
      return { score: undefined }
    },
    require: true,
    type: Object,
  },
  metricType: {
    default: 'list',
    require: false,
    type: String,
  },
  canViewMetricsInfo: {
    require: true,
    type: Boolean,
  },
}

export default {
  components: {
    HistoricChart,
    ModalPlans,
  },
  props: props,
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    classItem: function() {
      return `${this.metric.image ? '' : 'no-hover'}`
    },
    isChart: function() {
      return this.metricType === 'chart'
    },
    normalizeScore: function() {
      return this.metric.score
    },
  },
  methods: {
    metricLink: function() {
      if (!this.canViewMetricsInfo) {
        return this.$refs['component-modal-plans'].show()
      }

      if (this.metric.link) this.$router.push(this.metric.link)
    },
  },
  data: function() {
    return {
      score: undefined,
    }
  },
  created: function() {
    if (this.metric.score) {
      setInterval(() => (this.score = parseFloat(this.metric.score)))
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

_:-ms-fullscreen,
:root .ie-11-progress {
  background-color: green;
  max-width: 80%;
}

_:-ms-fullscreen,
:root .ie-11-img {
  height: 100px;
}

.wrapper {
  margin: 1%;
  min-width: 280px;
  width: 48%;

  @media (max-width: 700px) {
    width: 100%;
  }

  &.chart {
    width: 50%;
    margin: 0rem;

    @media (max-width: 700px) {
      width: 100%;
      border: 0px;
      &.wrapper:not(:nth-last-child(-n + 1)) {
        border-bottom: 0.5px solid map-get($theme-colors, 'gray07');
      }
    }

    @media (min-width: 768px) {
      &.wrapper:nth-of-type(odd) {
        border-right: 0.5px solid map-get($theme-colors, 'gray07');
      }

      &.wrapper:not(:nth-last-child(-n + 2)) {
        border-bottom: 0.5px solid map-get($theme-colors, 'gray07');
      }
    }
  }
}

.metric-item-chart {
  border: 0px;
  margin: 30px 0px 10px 20px;

  .metric-info {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;

    .label {
      font-size: 20px;
      font-weight: 500;
      color: map-get($theme-colors, 'gray04');

      @media (max-width: 1350px) {
        font-size: 16px !important;
      }
    }

    .show-details {
      color: map-get($theme-colors, 'gray03');
      font-size: 12px;
      font-weight: 500;
      text-decoration: none;
      margin-top: 0px;

      @media (max-width: 1350px) {
        font-size: 10px !important;
      }
    }
  }

  .icon {
    border-radius: 50%;
    min-height: 50px;
    min-width: 50px;

    div {
      min-height: inherit;
      height: 100%;
      width: 100%;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }

  .history {
    padding: 0px;
    margin-top: 20px;
  }
}

.metric-item {
  border: 1px solid rgba(83, 92, 145, 0.2);
  border-radius: 80px;
  color: map-get($theme-colors, 'light');
  display: flex;
  transition: all ease 0.3s;
  max-height: 100px;
  cursor: pointer;

  @media (max-width: 1350px) {
    max-height: 80px;
  }

  @media (max-width: 320px) {
    max-height: 80px;
  }

  .progress {
    background: white;
    border: 1px solid rgba(204, 204, 204, 0.5);
  }

  .icon {
    align-items: center;
    border-right: 1px solid rgba(83, 92, 145, 0.2);
    border-radius: inherit;
    color: white;
    display: flex;
    font-size: 4.2rem;
    justify-content: center;
    height: auto;
    min-height: 100px;
    min-width: 100px;
    max-width: 100px;
    overflow: hidden;

    @media (max-width: 1350px) {
      min-height: 80px;
      min-width: 80px;
      max-width: 80px;
    }

    @media (max-width: 320px) {
      min-height: 70px;
      min-width: 70px;
      max-width: 70px;
    }

    div {
      min-height: inherit;
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }

  &:hover {
    border: 1px solid
      lighten($color: map-get($theme-colors, 'purple01'), $amount: 40%);
    box-shadow: 0 3px 6px
      lighten($color: map-get($theme-colors, 'purple01'), $amount: 50%);
  }

  &.no-hover:hover {
    background: none;
    box-shadow: none;
    border: 0px;
    cursor: auto;
  }

  &.no-border {
    border: none;
  }

  .metric-info {
    border-radius: 0 8px 8px 0;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.5rem 1.2rem 0.7rem 0.5rem;
    margin: 0.5rem 0.6rem 0rem 0.7rem;
    width: 100%;

    @media (max-width: 1375px) {
      padding: 0.2rem 1rem 0.2rem 0rem;
    }

    h4 {
      border-radius: 30px;
      color: map-get($theme-colors, 'gray04');
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 0px;

      @media (max-width: 1350px) {
        font-size: 13px;
      }

      @media (max-width: 320px) {
        font-size: 14px;
      }
    }

    a {
      color: map-get($theme-colors, 'gray03');
      font-size: 12px;
      text-decoration: none;

      @media (max-width: 1350px) {
        font-size: 10px !important;
      }

      @media (max-width: 320px) {
        font-size: 9px !important;
      }
    }

    p {
      color: map-get($theme-colors, 'gray02');
      font-size: 12px;
      text-decoration: none;
      margin: 0;
    }

    .show-details {
      margin-top: 4px;
      font-weight: 500;
      font-size: 12px;
    }

    .bar {
      display: flex;
      align-items: center;

      .label {
        font-weight: 500;
        font-size: 29px;
        line-height: normal;
        margin-bottom: 5px;
        width: 65px;
        text-align: center;

        @media (max-width: 1350px) {
          font-size: 20px !important;
          width: 45px;
        }
      }

      .progress {
        height: 10px;
        border-radius: 30px;
        flex-basis: 100%;
        margin-right: 1rem;

        @media (max-width: 1350px) {
          height: 8px;
        }

        .progress-bar {
          border-radius: 30px;
        }
      }
    }
  }

  &.skeleton {
    .highlight {
      background: linear-gradient(
        70deg,
        map-get($theme-colors, 'light'),
        map-get($theme-colors, 'light'),
        white,
        map-get($theme-colors, 'light')
      );
      background-size: 300% 300%;
      animation: lightAnimate 1s ease infinite;
    }

    .icon {
      border-right: none;
    }

    .metric-info {
      h4 {
        height: 20px;
        width: 50%;
      }

      .bar {
        border-radius: 30px;
        height: 28px;
        margin-right: 1rem;
        width: 90%;
      }
    }

    @keyframes lightAnimate {
      0% {
        background-position: 100% 0%;
      }
      100% {
        background-position: 0% 0%;
      }
    }
  }
}
</style>
